import type { FC } from 'react';
import { Picture } from '@ui';
import icons from '@icons';

const {
  pin: { black: pinFilledBlack }
} = icons.Fill;

const {
  list: { black: listBlackOutlined }
} = icons.Outline;

interface MapListToggleProps {
  isShowMap: boolean;
  setIsShowMap: (val: boolean) => void;
}

const MapListToggle: FC<MapListToggleProps> = ({ isShowMap, setIsShowMap }) => (
  <div className='changerMapControl'>
    <div
      className='changerMapControl__friend'
      onClick={() => {
        setIsShowMap(false);
      }}
    >
      <Picture className='icon' icon={listBlackOutlined} height='14' alt='' />
      Список
    </div>
    <div
      className='changerMapControl__self'
      onClick={() => {
        setIsShowMap(true);
      }}
    >
      <Picture className='icon' icon={pinFilledBlack} height='14' alt='' />
      На карте
    </div>
    <div
      className={`changerMapControl__bg-slide${
        isShowMap ? ' changerMapControl__bg-slide--right' : ''
      }`}
    />
  </div>
);

export default MapListToggle;
